// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
export type ReviewOutcomeOutcomeJobOfferInfoFragment = {
  __typename?: 'JobOfferInfo';
  company: {
    __typename?: 'Company';
    id?: string | null;
    name: string;
    logoLink?: string | null;
  };
};

export type ReviewOutcomeOutcomeSchoolAdmissionInfoFragment = {
  __typename?: 'SchoolAdmissionInfo';
  status?: Types.SchoolAdmissionStatus | null;
  school: {
    __typename?: 'School';
    id: string;
    name: string;
    logoLink?: string | null;
  };
};

export type ReviewOutcomeOutcomeTestScoreV2Fragment = {
  __typename?: 'TestScoreV2';
  score: number;
  testName: string;
};

export type ReviewOutcomeOutcomeFragment =
  | ReviewOutcomeOutcomeJobOfferInfoFragment
  | ReviewOutcomeOutcomeSchoolAdmissionInfoFragment
  | ReviewOutcomeOutcomeTestScoreV2Fragment;

export type ReviewOutcomeSchoolAdmissionInfoFragment = {
  __typename?: 'SchoolAdmissionInfo';
  status?: Types.SchoolAdmissionStatus | null;
  school: {
    __typename?: 'School';
    id: string;
    name: string;
    logoLink?: string | null;
  };
};

export type ReviewOutcomeTestScoreV2Fragment = {
  __typename?: 'TestScoreV2';
  score: number;
  testName: string;
};

export type ReviewOutcomeJobOfferInfoFragment = {
  __typename?: 'JobOfferInfo';
  company: {
    __typename?: 'Company';
    id?: string | null;
    name: string;
    logoLink?: string | null;
  };
};

export const ReviewOutcomeSchoolAdmissionInfoFragmentDoc = gql`
  fragment ReviewOutcome_SchoolAdmissionInfo on SchoolAdmissionInfo {
    school {
      id
      name
      logoLink
    }
    status
  }
`;
export const ReviewOutcomeTestScoreV2FragmentDoc = gql`
  fragment ReviewOutcome_TestScoreV2 on TestScoreV2 {
    score
    testName
  }
`;
export const ReviewOutcomeJobOfferInfoFragmentDoc = gql`
  fragment ReviewOutcome_JobOfferInfo on JobOfferInfo {
    company {
      id
      name
      logoLink
    }
  }
`;
export const ReviewOutcomeOutcomeFragmentDoc = gql`
  fragment ReviewOutcome_Outcome on CoachingOutcomeUnion {
    ...ReviewOutcome_SchoolAdmissionInfo
    ...ReviewOutcome_TestScoreV2
    ...ReviewOutcome_JobOfferInfo
  }
  ${ReviewOutcomeSchoolAdmissionInfoFragmentDoc}
  ${ReviewOutcomeTestScoreV2FragmentDoc}
  ${ReviewOutcomeJobOfferInfoFragmentDoc}
`;
